import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { IItem } from '../models/IItem';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class ItemService {

  constructor(private db: AngularFirestore) { }

  ref = this.db.collection('items');
  types = ['Food', 'Beverages', 'Useful'];

  getAll() {
    return this.ref.snapshotChanges().pipe(map(actions => {
      return actions.map(action => {
        return {id: action.payload.doc.id, ...action.payload.doc.data() as IItem};
      });
    }));
  }

  get(id: string) {
    return this.ref.doc(id).snapshotChanges().pipe(map(action => {
      return {id: action.payload.id, ...action.payload.data() as IItem};
    }));
  }

  set(item: IItem, id: string) {
    if (id) { return this.ref.doc(id).update(item); }
    else { return this.ref.add(item); }
  }

  delete(id: string) {
    return this.ref.doc(id).delete();
  }

  uploadImage(file: File) {
    return firebase.storage().ref(`items/${file.name}`).put(file).then(snapshot => {
      return snapshot.ref.getDownloadURL();
    });
  }

  toggleVisibility(id: string, value: boolean) {
    return this.ref.doc(id).update({detailsVisibility: !value});
  }
}
